import React from 'react';
import { CalendarItem } from '@/services/calendarApi';
import { EVENT_TYPE_COLOR } from './eventTypes';

interface Props {
  month: Date; // any date within the month
  items: CalendarItem[];
  onDayClick: (d: Date) => void;
  onItemClick: (it: CalendarItem) => void;
}

const MonthGrid: React.FC<Props> = ({ month, items, onDayClick, onItemClick }) => {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const startDow = (first.getDay() + 6) % 7; // Monday=0
  const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const cells: (Date | null)[] = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++)
    cells.push(new Date(month.getFullYear(), month.getMonth(), d));

  const itemsFor = (d: Date) =>
    items.filter((it) => new Date(it.start).toDateString() === d.toDateString());

  return (
    <div>
      <div className="grid grid-cols-7 gap-1 text-xs font-semibold text-gray-500 dark:text-gray-400 mb-1">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((d) => (
          <div key={d} className="text-center py-1">
            {d}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => (
          <div
            key={i}
            onClick={() => d && onDayClick(d)}
            className={`min-h-[80px] rounded-md p-1 text-xs ${
              d
                ? 'bg-gray-50 dark:bg-gray-800/50 cursor-pointer hover:ring-1 hover:ring-blue-400'
                : ''
            }`}
          >
            {d && <div className="text-gray-400 text-[10px]">{d.getDate()}</div>}
            {d &&
              itemsFor(d)
                .slice(0, 4)
                .map((it) => (
                  <button
                    key={`${it.source}-${it.id}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onItemClick(it);
                    }}
                    className={`block w-full text-left text-white rounded px-1 mt-0.5 truncate ${
                      EVENT_TYPE_COLOR[it.type] || 'bg-gray-500'
                    }`}
                  >
                    {new Date(it.start).toLocaleTimeString(undefined, {
                      hour: '2-digit',
                      minute: '2-digit',
                    })}{' '}
                    {it.title}
                  </button>
                ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthGrid;
